import {
    LOADER_OFF,
    LOADER_ON,
} from 'store/actions/types';

export const loaderOff = () => {
    return {
        type: LOADER_OFF,
    };
};

export const loaderOn = () => {
    return {
        type: LOADER_ON,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/loaderActions.js